<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
    <div v-if="hasPermission">
      <l-data-table
        :get-data-func="getItems"
        :headers="headers"
        title-text="高级预约列表"
        v-model="selected"
        search-text="搜索分组名称"
        @click:row="goDetails($event.item)"
        clickable
        selectable
        ref="dataTable"
        :filter-items="filter"
        :init-pagination="{sortBy:'status',descending:true}"
      >
        <template slot="title-action">
          <l-option-menu
            :options="moreActions"
          >
            <v-btn icon slot="activator">
              <v-icon>$vuetify.icons.more</v-icon>
            </v-btn>
          </l-option-menu>
        </template>
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-btn @click="deleteItem(item)" icon :disabled="item.status==='-1'">
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="filter:host">
          <v-autocomplete
            :items="userSelect"
            v-model="filter[2].value"
            v-on:keyup="getHosts"
            label="联系人"
            clearable
            hide-details
            hide-selected
            item-text="loginId"
            item-value="loginId"
            prepend-icon="$vuetify.icons.person"
          >
            <template slot="no-data">
              <v-alert :value="true" color="error">
                暂无该用户信息
              </v-alert>
            </template>
            <template slot="item" slot-scope="props">
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-flex row align-center justify-between>
                    <span>{{props.item.name}}</span>
                  </v-flex>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
              </v-list-tile-action>
            </template>
          </v-autocomplete>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="goNew"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </div>
    <div v-else>
      {{errMsg}}}
    </div>
<!--    <v-layout justify-center>
      <v-btn flat color="primary" @click="showHistory=!showHistory">
        <span v-if="showHistory">隐藏高级预约历史列表</span>
        <span v-else>显示高级预约历史列表</span>
      </v-btn>
    </v-layout>
    <l-data-table
      v-if="showHistory"
      :get-data-func="getItemsHistory"
      :headers="headersHistory"
      @click:row="goDetails($event.item, true)"
      clickable
      init-sort-by="name"
      ref="historyTable"
      title-text="高级预约历史列表"
      v-model="selected"
      search-text="搜索分组名称"
    >
    </l-data-table>-->
  </l-layout>
</template>

<script>
import {GROUP_ACTION_HEADERS, GROUP_HEADERS} from '../../../consts/reservation'
import {ReservationAuthority} from '../../../object'
import {time} from '../../../ladmin/utils'
export default {
  name: 'ReservationGroupList',
  props: ['refresh'],
  data: () => ({
    selected: [],
    userSelect: [],
    floatingButton: false,
    showHistory: false,
    hasPermission:true,
    errMsg:"",
    moreActions: [
      {
        event: 'delete',
        label: '批量删除',
        icon: '$vuetify.icons.deleteAll'
      },
      // {
      //   event: 'export',
      //   label: '导出PDF',
      //   icon: '$vuetify.icons.description'
      // }
    ],
    headers: GROUP_ACTION_HEADERS,
    headersHistory: GROUP_HEADERS,
    filter: [
      {
        prependIcon: '$vuetify.icons.edit',
        key: 'status',
        value: '{"r_h_status":"1"}',
        label: '是否有效',
        type: 'select',
        layout: ['xs12', 'sm4'],
        items: [
          {
            value: '',
            text: '全部'
          },
          {
            value: '{"r_h_status":"1"}',
            text: '有效'
          },
          {
            value: '{"r_h_status":"-1"}',
            text: '失效'
          }],
      },
      {
        label: '过期时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'expirationTime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = v.startDatetime + ':00' || 0
            let e = v.endDatetime + ':00' || 9999999999999
            return [s, e]
          }
        }
      },
      {
        prependIcon: '$vuetify.icons.person',
        key: 'host',
        value: '',
        label: '联系人',
        type: 'input',
        layout: ['xs12', 'sm4'],
      },
    ]
  }),
  methods: {
    async getItems ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('reservation/getReservationGroups', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search},
      })
      let res = []
      for (let i in items) {
        let item = items[i]
        let j = JSON.parse(item.obgrp.rhdata) || {}
        let obj = {
          id: item.obgrp.id,
          name: item.obgrp.name,
          platePreview: item.platePreview,
          total: item.totalReg,
          host: item.user.name,
          phone: item.user.mobilePhone,
          creationTime: item.obgrp.creationTime,
          expirationTime: item.obgrp.expirationTime,
          status: j.r_h_status
        }
        //console.log(obj)
        res.push(obj)
      }
      return {items: res, amount: amount}
    },
    async getItemsHistory ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('reservation/getReservationGroupsHistory', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search},
      })
      let res = []
      for (let i in items) {
        let item = items[i]
        let obj = {
          id: item.obgrp.id,
          name: item.obgrp.name,
          platePreview: item.platePreview,
          total: item.totalReg,
          host: item.user.name,
          phone: item.user.mobilePhone,
          creationTime: item.obgrp.creationTime,
          expirationTime: item.obgrp.expirationTime
        }
        console.log(obj)
        res.push(obj)
      }
      return {items: res, amount: amount}
    },
    async deleteItem (type) {
      // console.log(user)
      if (!type) return
      let {res, close} = await this.$L.confirm({
        title: '确认删除该分组？',
        text: type.name || `N/A`,
        subText: '删除该分组会导致该分组下的预约车辆无法通行'
      })
      if (res) {
        try {
          await this.$store.dispatch('reservation/deleteGroups', [type])
          this.$refs.dataTable.refresh()
          this.$L.alert('success', {message: '删除成功'})
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    goDetails (item, isHistory) {
      this.getReservationConfig()
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'ReservationGroupDetails',
          params: {id: item.id},
          query: {id: item.id, status: item.status}
        })
      }
    },
    goNew () {
      this.getReservationConfig()
      this.$router.push({
        name: 'NewGroupReservation',
        path: 'new',
        query: {
          status: 'new',
          id: ''
        }
      })
    },
    async getReservationConfig () {
      let res = await this.$store.dispatch('reservationConfig/getReservationConfig', 'admin')
      console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '高级预约',
          maxVehicleAmount: 1000,
          maxStartDay: -1,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          type: ['sectional', 'day', 'week'],

          // 是否可以定义分组名称和描述
          editGroupInfo: true,

          // 是否可定义特殊进出场提示
          editPrompt: true
        })
        // console.log(object)
        this.$store.commit('reservation/setAdminAuth', object)
      }
      else {
        this.hasPermission = false
        this.errMsg = res.data.msg
       //this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async getHosts (param) {
      let search = (param === undefined) ? '' : param.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let searchParam = {
        'searchParam': {
          'loginId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.userSelect = res.data.data.content
      }
      else {
        this.userSelect = []
      }
    },
  },
  activated () {
/*    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }*/
    this.getReservationConfig()
  },
  created () {
  }
}
</script>

<style scoped>

</style>
